// extracted by mini-css-extract-plugin
export default {"bottom-banner":"bottom-banner--1Xbl1","bottom-banner__wrapper":"bottom-banner__wrapper--3kEm5","bottom-banner__wrapper--createCollection":"bottom-banner__wrapper--createCollection--jQll9","bottom-banner__text":"bottom-banner__text--glg49","bottom-banner__button":"bottom-banner__button--W1J6e","bottom-banner__close":"bottom-banner__close--3ixJk"};
    if(module.hot) {
      // 1747648153373
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  